import { Box, Divider } from '@mui/material';
import { Headings, LargeText, MediumText, NormalText } from 'components/atoms/Typography';
import CartCheckbox from 'components/CartCheckbox';
import useTranslation from 'next-translate/useTranslation';
import priorityImg from 'assets/svg/priority.svg';
import { useEffect, useState, useMemo } from 'react';
import { Cart, CustomerAddress, Region, Settings } from 'klikni-jadi-shared-stuff';
import { useCartService } from 'services/cart/useCartService';
import CartSwitch from 'components/CartSwitch';
import { collection, doc } from 'services/db/firestoreApi';
import AddNewAddress from 'components/AddNewAddress';
import { isEmpty, size, values } from 'lodash';
import { useLocationContext } from 'context/current-location';
import UserAddressMap from 'components/UserAddressMap';
import { useFirestore } from 'hooks/useFirestore';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';

interface IWhereToProps {
    cart: Cart;
    distance?: string;
}
interface Address {
    fullAddress: string;
    latitude: number;
    longitude: number;
}

const WhereTo = ({ cart, distance }: IWhereToProps) => {
    const { t } = useTranslation('common');
    const [openNewAddress, setOpenNewAddress] = useState<boolean>(false);
    const [forDelivery, setForDelivery] = useState<boolean>(cart?.type === 'delivery' ? true : false);
    const { changeType, addPriority, addAddressToHost } = useCartService();
    const [priority, setPriority] = useState<boolean>(cart?.isPriority);
    const customersRef = useFirestore('customers');
    const [newAddress, setNewAddress] = useState<[string, CustomerAddress]>(null);
    const [priorityFee, setPriorityFee] = useState<number>(null);
    const [realTakeoutDiscount, setRealTakeoutDiscount] = useState<number>(null);
    const user = useSelector((state: RootState) => state.currentUser);
    const [wrongChangesCount, setWrongChangesCount] = useState<number>(0);
    const { update } = useLocationContext();
    //     useEffect(()=>{
    // if(cart?.takeoutDiscountValue){
    //     const discount =
    // }
    //     },[])
    const handleTypeChange = type => {
        if (type !== cart.type) {
            changeType(type);
        }
    };
    console.log("newAddress", newAddress)

    useEffect(()=>{
        console.log("smena", cart?.host?.address)
        if(cart?.host?.address){
            setNewAddress([cart?.host?.address?.id , {...cart?.host?.address}])
        }
    },[cart?.host?.address])
    useEffect(() => {
        if (cart?.type) {
            setForDelivery(cart?.type === 'delivery' ? true : false);
        }
    }, [cart?.type]);

    const hasTakeout = useMemo(() => {
        return values(cart.groupedItems).every(item => item.restaurantAttributes?.hasSelfPickup);
    }, [cart]);

    useEffect(() => {
        if (!hasTakeout && cart?.type === 'takeout') {
            changeType('delivery');
        }
    }, [hasTakeout]);

    const handlePriorityChange = checked => {
        if (size(cart.groupedItems) > 0) {
            addPriority(checked, Object.values(cart.groupedItems)[0].region);
            setPriority(checked);
        }
    };
    useEffect(() => {
        if (cart?.groupedItems) {
            const region = Object.values(cart?.groupedItems)[0]?.region;
            doc<any>(`configuration/local/regions/${region}/settings`, 'fees').then(res => setPriorityFee(res?.priorityFee || 0));
        }
    }, [cart]);

    const partnerRegion = useMemo(() => {
        if (isEmpty(cart?.groupedItems)) return null;
        return values(cart?.groupedItems)[0].region;
    }, [cart?.groupedItems]);

    const differentRegions = useMemo(() => {
        if (!partnerRegion) return false;
        if (!cart?.host?.address?.region) return false;
        const _differentRegions = cart?.host?.address?.region !== partnerRegion;

        if (_differentRegions) {
            setOpenNewAddress(true);
        }

        return _differentRegions;
    }, [cart?.host?.address?.region, partnerRegion]);

    useEffect(() => {
        if (differentRegions) {
            setOpenNewAddress(true);
            setWrongChangesCount(w => w + 1);
        } else {
            setWrongChangesCount(0);
        }
    }, [differentRegions, cart?.host?.address?.fullAddress]);
    const handleAddressSave = async (address: [string, CustomerAddress]) => {
        setOpenNewAddress(false);
        address[1].approved = false;
        const newAddressId = customersRef.id();
        const locations = user.data.addresses;
        locations[newAddressId] = address[1];
        if (user.data) {
            customersRef
                .set(user.data.id, {
                    addresses: locations,
                })
                .then(() => {
                    if (addAddressToHost) {
                        addAddressToHost?.({ ...address[1], id: newAddressId });
                      
                        collection<Region>('configuration/local/regions').then(regions => {
                            let found;
                            for (const region of regions) {
                                if (
                                    region?.coordinates &&
                                    google.maps.geometry.poly.containsLocation(
                                        { lat: address[1]?.location?.latitude, lng: address[1]?.location?.longitude },
                                        new google.maps.Polygon({ paths: region.coordinates })
                                    )
                                ) {
                                    found = region?.id;
                                }
                            }
                            update('__data__', {
                                location: {
                                    latitude: address[1]?.location?.latitude,
                                    longitude: address[1]?.location?.longitude,
                                    fullAddress: address[1]?.fullAddress,
                                },
                                region: found,
                                addressId: newAddressId,
                            });
                        });
                    } 
                });
        }
    };

    // const handleAddressChangeAutocomplete = (address: CustomerAddress) => {
    //     addAddressToHost(address);

        // collection<Region>('configuration/local/regions').then(regions => {
        //     let found;
        //     for (const region of regions) {
        //         if (
        //             region?.coordinates &&
        //             google.maps.geometry.poly.containsLocation(
        //                 { lat: address?.location?.latitude, lng: address?.location?.longitude },
        //                 new google.maps.Polygon({ paths: region.coordinates })
        //             )
        //         ) {
        //             found = region?.id;
        //         }
        //     }
        //     update('__data__', {
        //         location: {
        //             latitude: address?.location?.latitude,
        //             longitude: address?.location?.longitude,
        //             fullAddress: address?.fullAddress,
        //         },
        //         region: found,
        //         addressId: address?.id,
        //     });
        // });

    //     setOpenChangeAddress(false);
    // };

    console.log('cart', cart);

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Headings.H2 sx={{ mb: 3 }}>{t('where_to')}</Headings.H2>
            <Box display="flex">
                <Box width="60px">
                    <CartCheckbox
                        checked={forDelivery}
                        handleCheck={() => {
                            setForDelivery(true);
                            handleTypeChange('delivery');
                        }}
                    />
                </Box>
                <Box onClick={() => setOpenNewAddress(true)} display="flex" flexDirection="column" sx={{ cursor: 'pointer' }}>
                    <Box display="flex">
                        <MediumText>
                            {t('delivery_to')}
                            {!cart?.host?.address?.title && ':'}
                        </MediumText>
                        {cart?.host?.address?.title && (
                            <>
                                &nbsp;
                                <MediumText
                                    semibold
                                    sx={{ color: differentRegions ? 'red' : 'primary.main', textDecoration: 'underline' }}
                                >
                                    {cart?.host?.address?.title}
                                </MediumText>
                            </>
                        )}
                        <MediumText sx={{ ml: 1 }}>({distance} km)</MediumText>
                    </Box>
                    <NormalText sx={{ color: differentRegions ? 'red' : 'gray' }}>{cart?.host?.address?.fullAddress}</NormalText>
                </Box>
            </Box>
            <Box pt={5} display="flex" alignItems="center" justifyContent="space-between" width="100%" pb={hasTakeout ? 0 : 5}>
                <Box display="flex" alignItems="center">
                    <Box width="60px">
                        <img src={priorityImg} width="25px" />
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <MediumText>{t('prioritize')}</MediumText>
                        {!!cart?.priorityCost && (
                            <NormalText sx={{ color: 'gray' }}>
                                {t('setToNow')} {cart?.priorityCost} {t('mkd')}
                            </NormalText>
                        )}
                    </Box>
                </Box>
                <CartSwitch checked={priority} handleSwitch={handlePriorityChange} />
            </Box>
            {hasTakeout && (
                <Box py={5} display="flex" alignItems="center">
                    <Box width="60px">
                        <CartCheckbox
                            checked={!forDelivery}
                            handleCheck={() => {
                                setForDelivery(false);
                                handleTypeChange('takeout');
                            }}
                        />
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <MediumText semibold>
                            {t('takeaway')} ({t('save_takeout')}
                            {cart?.takeoutSavings ? ` ${cart?.takeoutSavings} ${t('mkd')}` : ' 0'})
                        </MediumText>
                        <NormalText color="gray">{t('pickup_myself')}</NormalText>
                    </Box>
                </Box>
            )}
            {/* <AddNewAddress
                address={{
                    fullAddress: cart?.host?.address?.fullAddress,
                    latitude: cart?.host?.address?.location?.latitude,
                    longitude: cart?.host?.address?.location?.longitude,
                }}
                open={openChangeAddress}
                handleClose={() => setOpenChangeAddress(false)}
                addAddressToHost={handleAddressChangeAutocomplete}
                differentRegions={differentRegions}
                wrongChangesCount={wrongChangesCount}
            /> */}
             <UserAddressMap
                open={openNewAddress}
                address={newAddress}
                onClose={() => setOpenNewAddress(false)}
                onSave={handleAddressSave}
                inCart
            />
            <Divider />
        </Box>
    );
};

export default WhereTo;
